import { render, staticRenderFns } from "./SeoAgency.vue?vue&type=template&id=3070bf0a&"
import script from "./SeoAgency.vue?vue&type=script&lang=js&"
export * from "./SeoAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports